import React from 'react';
import { FadeIn } from './FadeIn';
export function Philosophy() {
  return <section id="philosophy" className="py-40 md:py-64 relative" data-id="element-117">
      <div className="max-w-[1200px] mx-auto px-6 md:px-12 flex flex-col items-center text-center" data-id="element-118">
        <FadeIn className="w-px h-24 bg-gradient-to-b from-transparent via-gold/50 to-transparent mb-16" data-id="element-119" />

        <FadeIn delay={0.2} data-id="element-120">
          <h2 className="serif text-3xl md:text-5xl lg:text-6xl leading-[1.4] text-charcoal max-w-4xl mx-auto" data-id="element-121">
            ״השקט שביצירה הוא המקום בו היופי האמיתי מתגלה. אנחנו לא מעצבים
            תכשיטים, אנחנו מפסלים אור.״
          </h2>
        </FadeIn>

        <FadeIn delay={0.4} className="mt-16" data-id="element-122">
          <span className="label-tiny text-charcoal/50" data-id="element-123">
            אלינור רוזן, מייסדת
          </span>
        </FadeIn>

        <FadeIn delay={0.6} className="w-px h-24 bg-gradient-to-b from-transparent via-gold/50 to-transparent mt-16" data-id="element-124" />
      </div>
    </section>;
}